import dayjs, { Dayjs } from 'dayjs/esm';

/**
 * Parses API / form "calendar" dates without timezone shift.
 * `new Date("2025-01-01")` is UTC midnight and can show as the previous/next local day.
 */
export function parseLocalCalendarDate(value: string | Date | Dayjs | null | undefined): Dayjs | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (dayjs.isDayjs(value)) {
    return value.startOf('day');
  }
  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return null;
    }
    return dayjs(value).startOf('day');
  }
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    return dayjs(new Date(y, m - 1, d)).startOf('day');
  }
  const parsed = dayjs(s);
  return parsed.isValid() ? parsed.startOf('day') : null;
}
